export enum pickupOrdersTypes {
    GET_PICKUP_ORDERS = '@@pickupOrders/GET_PICKUP_ORDERS',
    GET_PICKUP_ORDERS_SUCCESS = '@@pickupOrders/GET_PICKUP_ORDERS_SUCCESS',
    GET_PICKUP_ORDERS_FAIL = '@@pickupOrders/GET_PICKUP_ORDERS_FAIL',
  
    GET_MILESTONESCONFIG_PK = "@PK/GET_MILESTONECONFIG",
    GET_MILESTONESCONFIG_PK_SUCCESSS = "@PK/GET_MILESTONECONFIG_SUCCESS",
    GET_MILESTONESCONFIG_PK_FAIL = "@PK/GET_MILESTONECONFIG_FAIL"
  }
  